module.exports = __webpack_public_path__ + "img/Group 4.cc7504c0.svg";